export const config = [
    {
        title: "Home",
        link: "/"
    },
    {
        title: "Mutual Fund",
        children: [
            {
                title: "ALL Mutual Fund",
                link: "/mf"
            },
            {
                title: "NAV",
                link: "/mfnav"
            }
        ]
    },
    {
        title: 'Portfolio',
        link: "portfolio"
    },
    {
        title: 'Cron',
        link: "cron"
    }
]
